import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=158b5bee&scoped=true&"
import script from "./accountSetting.vue?vue&type=script&lang=js&"
export * from "./accountSetting.vue?vue&type=script&lang=js&"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=158b5bee&lang=scss&scoped=true&"
import style1 from "./accountSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b5bee",
  null
  
)

export default component.exports